import ItemByLocation from "../../slices/maintenance/maintenance/ItemByLocation";
import MaintenanceDetails from "../../slices/maintenance/maintenance/MaintenanceDetails";
import MaintenanceList from "../../slices/maintenance/maintenance/MaintenanceList";
import PartsDetails from "../../slices/maintenance/maintenance/PartsDetails";
import MaintenanceHierarchyList from "../../slices/maintenance/hierarchy/MaintenanceHierarchyList";
import HierarchyDetails from "../../slices/maintenance/hierarchy/HierarchyDetails";

const maintenanceReducer = {
    maintenanceList: MaintenanceList,
    itemByLocation: ItemByLocation,
    maintenanceDetails: MaintenanceDetails,
    partsDetails: PartsDetails,
    maintenanceHierarchyList: MaintenanceHierarchyList,
    hierarchyDetails: HierarchyDetails,
}

export default maintenanceReducer;